import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  ValidatorFn,
  AbstractControl,
  ValidationErrors,
} from "@angular/forms";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  NgbModalConfig,
  NgbModal,
  NgbModalOptions,
} from "@ng-bootstrap/ng-bootstrap";
import * as alertify from "alertifyjs";
import { BsModalService } from "ngx-bootstrap/modal";
import { finalize } from "rxjs";
import { ApiServiceService } from "src/app/Services/api-service.service";
import { AuthService } from "src/app/Services/auth.service";
import { ConfirmDialogComponent } from "src/app/Shared/shared/confirm-dialog/confirm-dialog.component";
import { CreateAdminComponent } from "src/app/Shared/shared/create-admin/create-admin.component";
import { ErrorDialogComponent } from "src/app/Shared/shared/error-dialog/error-dialog.component";
import { SuccessDialogComponent } from "src/app/Shared/shared/success-dialog/success-dialog.component";
import { Taxgroups } from "src/app/Shared/taxgroup.enum";

type TaxGroupType = "" | "USER" | "INFORMAL" | "COMPANY" | "MDA" | "AIRS"
const PAGE_SIZE = 10;

@Component({
  selector: "app-user-management-informal",
  templateUrl: "./user-management-informal.component.html",
  styleUrls: ["./user-management-informal.component.css"],
})
export class UserManagementInformalComponent implements OnInit {
  roles: any[] = [];
  userCounts: any;
  isEmpty: boolean = true;

  form: FormGroup;
  individualSearchForm: FormGroup;
  corporateSearchForm: FormGroup;
  details: any;
  isLoading: any;
  isSearching: any;
  count: number = 0;
  pageSize: number = PAGE_SIZE;
  page: number = 0;
  num: number = 1;
  currentPage: number = 1;
  private isRestoringFromUrlState = false;

  showSearch: boolean = false;
  showIndividualSearch: boolean = false;
  showCorporateSearch: boolean = false;

  individualPayerBg = "transparent";
  corporatePayerBg = "transparent";
  adminBg = "transparent";
  informalBg = "transparent";
  allPayerBg = "transparent";

  taxGroupSelected: TaxGroupType;
  selectedStatus: any;

  resetPasswordForm: FormGroup;

  showPassword: any;
  passwordMatch = true;
  passwordValid = true;

  userDetails: any;
  companyDetails: any;

  userId: any;
  editNonCompanyForm: FormGroup;
  userDisplayName: any;
  userEmail: any;
  editCompanyForm: FormGroup;

  editAdminForm: FormGroup;

  @ViewChild("newPasswordInput") newPasswordInput!: ElementRef;
  @ViewChild("confirmPasswordInput") confirmPasswordInput!: ElementRef;
  lgaList: any;
  occupationList: any;
  zones: any[];
  departments: any[];
  taxOffices: any[];
  taxgroups = Object.values(Taxgroups);
  departmentList: any[];

  constructor(
    config: NgbModalConfig,
    private modalService: NgbModal,
    private apiService: ApiServiceService,
    private authService: AuthService,
    private bsModalService: BsModalService,
    public fb: FormBuilder,
    private route: Router,
    private authenticationService: AuthService,
    private readonly activatedRoute: ActivatedRoute 
  ) {
    this.editAdminForm = this.fb.group({
      userId: [""],
      // phoneNumber: [
      //   "",
      //   [Validators.required, this.phoneNumberValidator.bind(this)],
      // ],
      // email: ["", [Validators.required, this.emailValidator()]],
      phoneNumber: [""],
      email: [""],
      address: ["", Validators.required],
      lgaId: [""],
      lgaName: [""],
      firstName: ["", Validators.required],
      lastName: ["", Validators.required],
      gender: [""],
      dob: [""],
      maritalStatus: [""],
      role: ["", Validators.required],
      department: ["", Validators.required],
      tax_group: ["", Validators.required],
      zone: ["", Validators.required],
      taxOffice: ["", Validators.required],
    });

    this.editNonCompanyForm = this.fb.group({
      userId: [""],
      // phoneNumber: [
      //   "",
      //   [Validators.required, this.phoneNumberValidator.bind(this)],
      // ],
      // email: ["", [Validators.required, this.emailValidator()]],
      phoneNumber: [""],
      email: [""],
      address: ["", Validators.required],
      lgaId: [""],
      lgaName: [""],
      firstName: ["", Validators.required],
      lastName: ["", Validators.required],
      gender: [""],
      occupationId: [""],
      dob: [""],
      maritalStatus: [""],
      nin: ["", Validators.required],
      tin: ["", Validators.required],
      // role: [""],
    });

    this.editCompanyForm = this.fb.group({
      userId: [""],
      // phoneNumber: [
      //   "",
      //   [Validators.required, this.phoneNumberValidator.bind(this)],
      // ],
      // email: ["", [Validators.required, this.emailValidator()]],
      phoneNumber: [""],
      email: [""],
      address: ["", Validators.required],
      lgaId: [""],
      lgaName: [""],
      corporateName: ["", Validators.required],
      classification: [""],
      natureOfBusiness: [""],
      rcNumber: [""],
      tin: [""],
    });

    this.showPassword = "password";

    this.resetPasswordForm = this.fb.group({
      newPassword: [
        "",
        [Validators.required, Validators.minLength(8)],
        [this.passwordValidator()], // Set async validator using setAsyncValidators
      ],
      confirmPassword: [
        "",
        [Validators.required, Validators.minLength(8)],
        [this.passwordValidator()], // Set async validator using setAsyncValidators
      ],
    });

    config.backdrop = "static";
    config.keyboard = false;
  }

  ngOnInit(): void {
    // this.taxGroupSelected = "";
    this.selectedStatus = "ACTIVE";
    // this.allPayerBg = "white";

    this.initializeForm();
    this.initializeIndividualSearchForm();
    this.initializeCompanySearchForm();
    this.getAllLga();
    this.getAllOccupation();
    this.getCounts();
    // this.search();
    this.getRoles();
    this.getZones();
    this.getAllBusinessClassifications();
    this.getAllNatureOfBusinessList();

    this.processRouteData();
  }

  private processRouteData() {
    const queryParams = this.activatedRoute.snapshot.queryParams;
    const taxGroup = queryParams['taxGroup'] ?? "";
    this.taxGroupSelected = (taxGroup as TaxGroupType);
    
    switch (taxGroup) {
      case "":
        this.allPayerBg = "white";
        break;
      case "USER":
        this.individualPayerBg = "white";
        break;
      case "COMPANY":
        this.corporatePayerBg = "white";
        break;
      case "MDA":
        this.adminBg = "white";
        break;
      case "INFORMAL":
        this.informalBg = "white";
        break;
    }

    this.activatedRoute.queryParams.subscribe({
      next: (params: Params) => {
        this.searchFromRoute(params);
      }
    })
  }

  businessClassificationList: any[] = [];
  getAllBusinessClassifications() {
    this.apiService.get("/assessments/business_categories").subscribe(
      (reponse) => {
        this.businessClassificationList = reponse;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  natureOfBusinessList: any[] = [];
  getAllNatureOfBusinessList() {
    this.apiService.LoginGet("/auth/utility/business_nature/all").subscribe(
      (reponse) => {
        this.natureOfBusinessList = reponse;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  initializeForm() {
    this.form = this.fb.group({
      searchBy: [""],
      status: [""],
      offset: [""],
    });

    const queryParams = this.activatedRoute.snapshot.queryParams;
    this.form.patchValue({
      searchBy: queryParams["searchBy"] ?? "",
      status: queryParams["status"] ?? "",
      offset: queryParams["offset"] ?? "",
    })
  }

  initializeIndividualSearchForm() {
    this.individualSearchForm = this.fb.group({
      name: [""],
      asin: [""],
      phoneNumber: [""],
      email: [""],
      lg: [""],
      from: [""],
      to: [""],
      presumptiveProfiled: [""],
      offset: [""],
      hasNIN: [""],
      nin: [""],
    });

    const queryParams = this.activatedRoute.snapshot.queryParams;
    this.individualSearchForm.patchValue({
      name: queryParams["name"] ?? "",
      asin: queryParams["asin"] ?? "",
      phoneNumber: queryParams["phoneNumber"] ?? "",
      email: queryParams["email"] ?? "",
      lg: queryParams["lg"] ?? "",
      from: queryParams["from"] ?? "",
      to: queryParams["to"] ?? "",
      presumptiveProfiled: queryParams["presumptiveProfiled"] ?? "",
      offset: queryParams["offset"] ?? "",
      hasNIN: queryParams["hasNIN"] ?? "",
      nin: queryParams["nin"] ?? "",
    })
  }

  initializeCompanySearchForm() {
    this.corporateSearchForm = this.fb.group({
      name: [""],
      asin: [""],
      phoneNumber: [""],
      email: [""],
      classification: [""],
      natureOfBusiness: [""],
      lg: [""],
      from: [""],
      to: [""],
      fireServiceProfiled: [""],
      businessPremisesProfiled: [""],
      offset: [""],
    });

    const queryParams = this.activatedRoute.snapshot.queryParams;
    this.corporateSearchForm.patchValue({
      name: queryParams["name"] ?? "",
      asin: queryParams["asin"] ?? "",
      phoneNumber: queryParams["phoneNumber"] ?? "",
      email: queryParams["email"] ?? "",
      classification: queryParams["classification"] ?? "",
      natureOfBusiness: queryParams["natureOfBusiness"] ?? "",
      lg: queryParams["lg"] ?? "",
      from: queryParams["from"] ?? "",
      to: queryParams["to"] ?? "",
      fireServiceProfiled: queryParams["fileServiceProfiled"] ?? "",
      businessPremisesProfiled: queryParams["businessPremisesProfiled"] ?? "",
      offset: queryParams["offset"] ?? "",
    })
  }

  toggleSearch() {
    this.showIndividualSearch = !this.showIndividualSearch;
  }

  toggleCompanySearch() {
    this.showCorporateSearch = !this.showCorporateSearch;
  }

  getDepartments(event: Event) {
    this.editAdminForm.patchValue({
      department: "",

      zone: "",

      taxOffice: "",
    });

    const type = (event.target as HTMLSelectElement).value;
    this.apiService
      .loginPost_("/auth/utility/departments?group=" + type, {})
      .subscribe({
        next: (res: any) => {
          this.departments = res.map((department: any) =>
            department.name.toUpperCase()
          );

          this.departmentList = res;
        },
        error: (err: any) => {
          console.log(err);
        },
      });
  }

  loadDepartment(type: any) {
    this.apiService
      .loginPost_("/auth/utility/departments?group=" + type, {})
      .subscribe({
        next: (res: any) => {
          this.departmentList = res;

          this.editAdminForm.patchValue({
            department: this.userDetails?.department || "",

            zone: this.userDetails?.zone || "",
          });

          this.loadTaxOffice(this.userDetails?.zone);
        },
        error: (err: any) => {
          console.log(err);
        },
      });
  }

  getZones() {
    this.apiService.loginPost_("/auth/utility/zone", {}).subscribe({
      next: (res: any) => {
        this.zones = res;
      },
      error: (err: any) => {
        console.log(err);
      },
    });
  }

  getTaxOffice(event: Event) {
    this.editAdminForm.patchValue({
      taxOffice: "",
    });

    const zoneId = (event.target as HTMLSelectElement).value;
    this.apiService
      .loginPost_("/auth/utility/taxoffice?zone=" + zoneId, {})
      .subscribe({
        next: (res: any) => {
          this.taxOffices = res;
        },
      });
  }

  loadTaxOffice(zoneId: any) {
    this.apiService
      .loginPost_("/auth/utility/taxoffice?zone=" + zoneId, {})
      .subscribe({
        next: (res: any) => {
          this.taxOffices = res;

          this.editAdminForm.patchValue({
            taxOffice: this.userDetails?.taxOffice || "",
          });
        },
      });
  }

  hasAccess(permissions: string[]) {
    return this.authenticationService.hasAnyPermission(permissions);
  }

  getRoles() {
    this.authService.getRoles().subscribe((res: any) => {
      this.roles = res;
    });
  }

  phoneNumberValidator(control: any) {
    const phoneNumber = control.value;
    if (!phoneNumber) {
      return { required: true }; // Required validation error
    }

    // Remove spaces and hyphens and check if the result contains only digits
    const cleanedPhoneNumber = phoneNumber.replace(/\s/g, "").replace(/-/g, "");
    const isDigitsOnly = /^\d+$/.test(cleanedPhoneNumber);

    // Check if the input is exactly 11 digits, 13 digits starting with '234', or 14 characters starting with '+234'
    if (
      (cleanedPhoneNumber.length === 11 && isDigitsOnly) ||
      (cleanedPhoneNumber.length === 13 &&
        cleanedPhoneNumber.startsWith("234")) ||
      (cleanedPhoneNumber.length === 14 &&
        cleanedPhoneNumber.startsWith("+234"))
    ) {
      return null; // Valid phone number
    } else {
      return { invalidPhoneNumber: true }; // Invalid phone number format
    }
  }

  getAllLga() {
    this.apiService.LoginGet("/auth/lga/all").subscribe(
      (reponse) => {
        this.lgaList = reponse;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getAllOccupation() {
    this.apiService.LoginGet("/auth/occupation/all").subscribe(
      (reponse) => {
        this.occupationList = reponse;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  confirmEdit() {
    let dfModalRef = this.bsModalService.show(ConfirmDialogComponent, {
      initialState: {
        body: "Proceed to save changes",
      },
      class: "modal-sm modal-dialog-centered",
    });
    dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
      this.saveNonCompanyEdits();
      dfModalRef.hide();
    });
  }

  confirmCompanyEdit() {
    let dfModalRef = this.bsModalService.show(ConfirmDialogComponent, {
      initialState: {
        body: "Proceed to save changes",
      },
      class: "modal-sm modal-dialog-centered",
    });
    dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
      this.saveCompanyEdits();
      dfModalRef.hide();
    });
  }

  confirmAdminEdit() {
    let dfModalRef = this.bsModalService.show(ConfirmDialogComponent, {
      initialState: {
        body: "Proceed to save changes",
      },
      class: "modal-sm modal-dialog-centered",
    });
    dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
      this.saveAdminEdits();
      dfModalRef.hide();
    });
  }

  saveCompanyEdits() {
    this.isLoading = true;

    let pojo = this.editCompanyForm.value;

    pojo["userId"] = this.userId;

    const url = "/auth/edit-user-details";

    this.apiService.loginPost_(url, pojo).subscribe(
      (response) => {
        this.isLoading = false;

        if (response.status == "OK") {
          this.confirmAfterSuccess(response.message);
          alertify.set("notifier", "position", "top-center");
          alertify.success("Account has been successfully updated");
        } else {
          this.confirmAfterError("Action was not successful");
          alertify.set("notifier", "position", "top-center");
          alertify.error("Error performing this operation");
        }
      },
      (error) => {
        console.log(error);
        this.confirmAfterError("Action was not successful");
        alertify.set("notifier", "position", "top-center");
        alertify.error("Error performing this operation");
        this.isLoading = false;
      }
    );
  }

  saveNonCompanyEdits() {
    this.isLoading = true;

    let pojo = this.editNonCompanyForm.value;

    pojo["userId"] = this.userId;

    const url = "/auth/edit-user-details";

    this.apiService.loginPost_(url, pojo).subscribe(
      (response) => {
        this.isLoading = false;

        if (response.status == "OK") {
          this.confirmAfterSuccess(response.message);
          alertify.set("notifier", "position", "top-center");
          alertify.success("Account has been successfully updated");
        } else {
          this.confirmAfterError("Action was not successful");
          alertify.set("notifier", "position", "top-center");
          alertify.error("Error performing this operation");
        }
      },
      (error) => {
        console.log(error);
        this.confirmAfterError("Action was not successful");
        alertify.set("notifier", "position", "top-center");
        alertify.error("Error performing this operation");
        this.isLoading = false;
      }
    );
  }

  saveAdminEdits() {
    this.isLoading = true;

    let pojo = this.editAdminForm.value;

    pojo["userId"] = this.userId;

    const url = "/auth/edit-user-details";

    this.apiService.loginPost_(url, pojo).subscribe(
      (response) => {
        this.isLoading = false;

        if (response.status == "OK") {
          this.confirmAfterSuccess(response.message);
          alertify.set("notifier", "position", "top-center");
          alertify.success("Account has been successfully updated");
        } else {
          this.confirmAfterError("Action was not successful");
          alertify.set("notifier", "position", "top-center");
          alertify.error("Error performing this operation");
        }
      },
      (error) => {
        console.log(error);
        this.confirmAfterError("Action was not successful");
        alertify.set("notifier", "position", "top-center");
        alertify.error("Error performing this operation");
        this.isLoading = false;
      }
    );
  }

  emailValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      // Regular expression for a strict email format validation
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

      if (control.value && !emailPattern.test(control.value)) {
        return { invalidEmail: true };
      }

      return null;
    };
  }

  getUserDetails() {
    let request = {
      userId: this.userId,
      taxGroup: this.taxGroupSelected,
    };

    const url = "/auth/user/details";

    if (
      this.taxGroupSelected != "COMPANY" &&
      this.taxGroupSelected != "INFORMAL" &&
      this.taxGroupSelected != "MDA" &&
      this.taxGroupSelected != "AIRS"
    ) {
      this.apiService.loginPost_(url, request).subscribe(
        (response) => {
          this.userDetails = response;

          this.editNonCompanyForm.patchValue({
            firstName: this.userDetails?.firstName || "",
            phoneNumber: this.userDetails?.phoneNumber || "",
            email: this.userDetails?.email || "",
            address: this.userDetails?.address || "",
            lastName: this.userDetails?.lastName || "",
            nin: this.userDetails?.nin || "",
            tin: this.userDetails?.tin || "",
            // role: this.userDetails?.role || "",
          });

          this.isLoading = false;
        },
        (error) => {
          alertify.set("notifier", "position", "top-center");
          alertify.error("Error performing this operation");
          this.isLoading = false;
        }
      );
    } else if (
      this.taxGroupSelected == "MDA" ||
      this.taxGroupSelected == "AIRS"
    ) {
      this.apiService.loginPost_(url, request).subscribe(
        (response) => {
          this.userDetails = response;

          this.editAdminForm.patchValue({
            firstName: this.userDetails?.firstName || "",
            phoneNumber: this.userDetails?.phoneNumber || "",
            email: this.userDetails?.email || "",
            address: this.userDetails?.address || "",
            lastName: this.userDetails?.lastName || "",
            role: this.userDetails?.role || "",
            tax_group: this.userDetails?.taxGroupName || "",
          });

          this.loadDepartment(this.userDetails?.taxGroupName);

          this.isLoading = false;
        },
        (error) => {
          alertify.set("notifier", "position", "top-center");
          alertify.error("Error performing this operation");
          this.isLoading = false;
        }
      );
    } else {
      this.apiService.loginPost_(url, request).subscribe(
        (response) => {
          this.companyDetails = response;

          this.editCompanyForm.patchValue({
            corporateName: this.companyDetails?.displayName || "",
            phoneNumber: this.companyDetails?.phoneNumber || "",
            email: this.companyDetails?.email || "",
            rcNumber: this.companyDetails?.rcNumber || "",
            tin: this.companyDetails?.tin || "",
            address: this.companyDetails?.address || "",
          });

          this.isLoading = false;
        },
        (error) => {
          alertify.set("notifier", "position", "top-center");
          alertify.error("Error performing this operation");
          this.isLoading = false;
        }
      );
    }
  }

  reset() {
    this.resetPasswordForm.reset();
  }

  passwordValidator(): ValidatorFn {
    return (
      control: AbstractControl
    ): Promise<ValidationErrors | null> | null => {
      const value: string = control.value;

      const hasLowercase = /[a-z]/.test(value);
      const hasUppercase = /[A-Z]/.test(value);
      const hasNumeric = /[0-9]/.test(value);
      const hasSymbol = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(value);

      // Check if all criteria are met
      const isPasswordValid =
        hasLowercase && hasUppercase && hasNumeric && hasSymbol;

      this.passwordValid = isPasswordValid;
      // Return the validation result as a Promise
      return isPasswordValid
        ? Promise.resolve(null)
        : Promise.resolve({ passwordRequirements: true });
    };
  }

  edit(userId: any, displayName: any) {
    this.userId = userId;
    this.userDisplayName = displayName;
  }

  deactivate(userId: any, email: any) {
    this.userId = userId;
    this.userEmail = email;
  }
  Activate(userId: any, email: any) {
    this.userId = userId;
    this.userEmail = email;
  }

  resetPassword(userId: any, displayName: any) {
    this.userId = userId;
    this.userDisplayName = displayName;
  }

  unlock(userId: any, email: any) {
    this.userId = userId;
    this.userEmail = email;
  }

  confirmUnlock() {
    let dfModalRef = this.bsModalService.show(ConfirmDialogComponent, {
      initialState: {
        body: "Are you sure you want to unlock " + this.userEmail,
      },
      class: "modal-sm modal-dialog-centered",
    });
    dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
      this.saveUserUnlock();
      dfModalRef.hide();
    });
  }

  saveUserUnlock() {
    const url = "/auth/unlock";
    let formData: any = new FormData();

    formData.append("email", this.userEmail);

    this.apiService.login(url, formData).subscribe(
      (response) => {
        this.confirmAfterSuccess("Action was successful");
        alertify.set("notifier", "position", "top-center");
        alertify.success(this.userEmail + " has been successfully Activated");

        this.isLoading = false;
      },
      (error) => {
        this.confirmAfterError("Action was not successful");
        this.isLoading = false;
        alertify.set("notifier", "position", "top-center");
        alertify.error("Error performing this operation");
        this.isLoading = false;
      }
    );
  }

  confirmActivate() {
    let dfModalRef = this.bsModalService.show(ConfirmDialogComponent, {
      initialState: {
        body: "Are you sure you want to activate " + this.userEmail,
      },
      class: "modal-sm modal-dialog-centered",
    });
    dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
      this.saveUserActivation();
      dfModalRef.hide();
    });
  }

  saveUserActivation() {
    const url = "/auth/activate";
    let formData: any = new FormData();

    formData.append("userId", this.userId);

    this.apiService.login(url, formData).subscribe(
      (response) => {
        this.confirmAfterSuccess("Action was successful");
        alertify.set("notifier", "position", "top-center");
        alertify.success(this.userEmail + " has been successfully Activated");

        this.isLoading = false;
      },
      (error) => {
        this.confirmAfterError("Action was not successful");
        this.isLoading = false;
        alertify.set("notifier", "position", "top-center");
        alertify.error("Error performing this operation");
        this.isLoading = false;
      }
    );
  }

  // confirmDeactivate() {
  //   let dfModalRef = this.bsModalService.show(ConfirmDialogComponent, {
  //     initialState: {
  //       body: "Are you sure you want to deactivate " + this.userEmail,
  //     },
  //     class: "modal-sm modal-dialog-centered",
  //   });
  //   dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
  //     this.saveUserDeactivation();
  //     dfModalRef.hide();
  //   });
  // }

  saveUserDeactivation(userId: number) {
    const url = "/auth/deactivate-by-admin";
    let formData: any = new FormData();

    formData.append("userId", userId);

    this.apiService.login(url, formData).subscribe(
      (response) => {
        this.confirmAfterSuccess("Action was successful");
        alertify.set("notifier", "position", "top-center");
        alertify.success("User has been successfully deactivated");

        this.search()

        this.isLoading = false;
      },
      (error) => {
        this.confirmAfterError("Action was not successful");
        this.isLoading = false;
        alertify.set("notifier", "position", "top-center");
        alertify.error("Error performing this operation");
        this.isLoading = false;
      }
    );
  }

  confirmReset() {
    if (
      this.resetPasswordForm.get("newPassword")?.value ===
        this.resetPasswordForm.get("confirmPassword")?.value &&
      this.passwordValid
    ) {
      this.passwordMatch = true;
      let dfModalRef = this.bsModalService.show(ConfirmDialogComponent, {
        initialState: {
          body:
            "Are you sure you want to reset the password for " +
            this.userDisplayName,
        },
        class: "modal-sm modal-dialog-centered",
      });
      dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
        this.savePasswordReset();
        dfModalRef.hide();
      });
    } else {
      this.passwordMatch = false;
    }
  }

  savePasswordReset() {
    const url = "/auth/save-password-reset";

    let formData: any = new FormData();

    formData.append("userId", this.userId);

    formData.append(
      "newPassword",
      this.resetPasswordForm.get("newPassword")?.value
    );

    this.apiService.login(url, formData).subscribe(
      (response) => {
        if (response.status == "OK") {
          this.confirmAfterSuccess("Action was successful");
          alertify.set("notifier", "position", "top-center");
          alertify.success("Password reset was successful");
        } else {
          this.confirmAfterError("Error resetting password. Try again");
        }

        this.isLoading = false;
      },
      (error) => {
        this.confirmAfterError("Action was not successful");
        this.isLoading = false;
        alertify.set("notifier", "position", "top-center");
        alertify.error("Error performing this operation");
        this.isLoading = false;
      }
    );
  }

  confirmAfterSuccess(message: any) {
    let dfModalRef = this.bsModalService.show(SuccessDialogComponent, {
      initialState: {
        body: message,
      },
      class: "modal-sm modal-dialog-centered",
    });
    dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
      dfModalRef.hide();
    });
  }

  confirmAfterError(message: any) {
    let dfModalRef = this.bsModalService.show(ErrorDialogComponent, {
      initialState: {
        body: message,
      },
      class: "modal-sm modal-dialog-centered",
    });
    dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
      dfModalRef.hide();
    });
  }

  open(content: any) {
    this.modalService.open(content, { centered: true, size: "lg" });
  }

  openPassword(content: any) {
    this.modalService.open(content, { centered: true, size: "md" });
  }

  openReset(content: any) {
    this.modalService.open(content, { centered: true, size: "md" });
  }

  togglePassword() {
    if (this.showPassword == "text") {
      this.showPassword = "password";
    } else if (this.showPassword == "password") {
      this.showPassword = "text";
    }
  }

  getCounts() {
    this.apiService.LoginGet("/auth/users-counts").subscribe(
      (reponse) => {
        this.userCounts = reponse;
      },
      (error) => {}
    );
  }

  filterBySelectedValue(event: any) {
    this.selectedStatus = event.target.value || ""; // Use an empty string for "All" option
    this.search();
  }

  onPageChange(page: number): void {
    if (this.isRestoringFromUrlState || page === this.currentPage) return;
    this.page = page - 1;
    this.search();
  }

  private searchFromRoute(params: {[key: string]: any}) {
    this.isRestoringFromUrlState = true;
    const paramEntries = Object.entries(params);
    let formData: FormData = new FormData();
    let url = "";

    this.page = Number(params['page']) || 0;
    this.pageSize = Number(params['pageSize']) || 10;
    this.num = Number(params['offset']) || 0;
    this.currentPage = this.page + 1;
    
    paramEntries.forEach(([key, value]) => {
      formData.append(key, value);
    })
    this.isEmpty = false;

    if (this.taxGroupSelected == "" || this.taxGroupSelected == "MDA") {
      url = "/auth/non-admin/users/search";
    }

    if (this.taxGroupSelected == "USER") {
      url = "/auth/users/search/individual";
    }

    if (
      this.taxGroupSelected == "INFORMAL" ||
      this.taxGroupSelected == "COMPANY"
    ) {
      url = "/auth/users/search/corporate";
    }

    this.isSearching = true;
    this.apiService.login(url, formData).pipe(finalize(() => {
      this.isRestoringFromUrlState = false;
      this.isSearching = false;
    })).subscribe(
      (response) => {
        this.details = response.results;
        if (this.details.length > 0) {
          this.isLoading = false;
          this.count = Math.ceil(response.total);
          this.isSearching = false;
        } else {
          this.isLoading = false;
          this.isSearching = false;
          this.isEmpty = true;
        }
      },
      (error) => {
        this.isLoading = false;
        alertify.set("notifier", "position", "top-center");
        alertify.error("Error performing this operation");
        this.isEmpty = true;
      }
    );
  }

  search(reset?: boolean) {
    this.isEmpty = false;
    this.num = this.page * 5;

    const queryParams: {[key: string]: any} = {
      page: this.page ?? 0,
      pageSize: this.pageSize ?? PAGE_SIZE,
      offset: this.num
    };

    queryParams["taxGroup"] = this.taxGroupSelected;

    if (reset) {
      this.count = 0;
      queryParams["page"] = 0;
      queryParams["pageSize"] = PAGE_SIZE;
      queryParams["offset"] = 0;
      this.resetForm();
      this.route.navigate([],{
        relativeTo: this.activatedRoute,
        queryParams: queryParams,
        replaceUrl: true,
      });
      return;
    }

    if (this.taxGroupSelected == "" || this.taxGroupSelected == "MDA") {
      queryParams["searchBy"] = this.form.get("searchBy")?.value;
      queryParams["taxGroup"] = this.taxGroupSelected;

      const selectedStatus = this.selectedStatus;

      // Only append the status if it's not an empty string (All)
      if (selectedStatus != "") {
        queryParams["status"] = selectedStatus;
      }
    }

    if (this.taxGroupSelected == "USER") {
      queryParams["name"] = this.individualSearchForm.get("name")?.value;
      queryParams["asin"] = this.individualSearchForm.get("asin")?.value
      queryParams["phoneNumber"] = this.individualSearchForm.get("phoneNumber")?.value;
      queryParams["hasNIN"] = this.individualSearchForm.get("hasNIN")?.value;
      queryParams["nin"] = this.individualSearchForm.get("nin")?.value;
      queryParams["email"] = this.individualSearchForm.get("email")?.value
      queryParams["lg"] = this.individualSearchForm.get("lg")?.value;
      queryParams["from"] = this.individualSearchForm.get("from")?.value;
      queryParams["to"] = this.individualSearchForm.get("to")?.value;
      queryParams["presumptiveProfiled"] = this.individualSearchForm.get("presumptiveProfiled")?.value;
    }

    if (
      this.taxGroupSelected == "INFORMAL" ||
      this.taxGroupSelected == "COMPANY"
    ) {
      queryParams["taxGroup"] = this.taxGroupSelected;
      queryParams["name"] = this.corporateSearchForm.get("name")?.value;
      queryParams["asin"] = this.corporateSearchForm.get("asin")?.value;
      queryParams["phoneNumber"] = this.corporateSearchForm.get("phoneNumber")?.value;
      queryParams["email"] = this.corporateSearchForm.get("email")?.value;
      queryParams["lg"] = this.corporateSearchForm.get("lg")?.value;
      queryParams["classification"] = this.corporateSearchForm.get("classification")?.value;
      queryParams["natureOfBusiness"] = this.corporateSearchForm.get("natureOfBusiness")?.value;
      queryParams["from"] = this.corporateSearchForm.get("from")?.value;
      queryParams["to"] = this.corporateSearchForm.get("to")?.value;
      queryParams["fireServiceProfiled"] = this.corporateSearchForm.get("fireServiceProfiled")?.value;
      queryParams["businessPremisesProfiled"] = this.corporateSearchForm.get("businessPremisesProfiled")?.value;
    }

    this.route.navigate([],{
      relativeTo: this.activatedRoute,
      queryParams: queryParams,
      replaceUrl: true,
    });
  }

  changeBackgroundColor(buttonType: TaxGroupType) {
    this.showCorporateSearch = false;
    this.showIndividualSearch = false;

    // Reset background color for all buttons
    this.allPayerBg = "transparent";
    this.individualPayerBg = "transparent";
    this.corporatePayerBg = "transparent";
    this.adminBg = "transparent";
    this.informalBg = "transparent";

    // Set background color to white for the clicked button
    switch (buttonType) {
      case "":
        this.allPayerBg = "white";
        // this.page = 0;
        this.taxGroupSelected = "";
        this.search(true);
        break;
      case "USER":
        this.individualPayerBg = "white";
        // this.page = 0;
        this.taxGroupSelected = buttonType;
        this.search(true);
        break;
      case "COMPANY":
        this.corporatePayerBg = "white";
        // this.page = 0;
        this.taxGroupSelected = buttonType;
        this.search(true);
        break;
      case "MDA":
        this.adminBg = "white";
        // this.page = 0;
        this.taxGroupSelected = buttonType;
        this.search(true);
        break;
      case "INFORMAL":
        this.informalBg = "white";
        // this.page = 0;
        this.taxGroupSelected = buttonType;
        this.search(true);
        break;
    }
  }

  resetForm() {
    this.initializeCompanySearchForm();
    this.initializeIndividualSearchForm();
  }

  extractFirstAlphabets(displayName: string) {
    const words = displayName.split(" ");
    let firstAlphabets = words
      .map((word) => word.charAt(0))
      .join("")
      .toUpperCase();

    return firstAlphabets;
  }

  viewProfile(id: any) {
    this.route.navigate(["general/user-profile"], {
      queryParams: { page: id },
    });
  }

  printAsinCard(type: string, asin: string) {
    // this.spinner.spin()
    let url = "";
    const normalizedType = type?.toUpperCase();

    if (
      normalizedType === "COMPANY" ||
      normalizedType === "CORPORATE" ||
      normalizedType === "INFORMAL"
    ) {
      url = `/auth/enumeration/print/asin/card/corporate/${asin}`;
    } else if (normalizedType === "USER" || normalizedType === "INDIVIDUAL") {
      url = `/auth/enumeration/print/asin/card/individual/${asin}`;
    }

    alertify.set("notifier", "position", "top-center");
    alertify.success("Downloading ...");

    this.apiService.login(url, {}, { responseType: "blob" }).subscribe(
      (response: Blob) => {
        alertify.set("notifier", "position", "top-center");
        alertify.success("Download successful");

        const blob = new Blob([response], { type: "application/pdf" });

        // Create a Blob URL for the PDF content
        const blobUrl = window.URL.createObjectURL(blob);

        // Open PDF in a new tab
        // window.open(blobUrl, '_blank');

        const file = new Blob([response], { type: "application/pdf" });

        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);

        // Optionally, trigger a download by creating an anchor element
        const downloadLink = document.createElement("a");
        downloadLink.href = blobUrl;
        downloadLink.target = "_blank";
        downloadLink.download = asin + "_asin_card.pdf"; // File name for download

        // Uncomment this line to trigger the download automatically
        downloadLink.click();
        // this.spinner.hide();
      },
      (error) => {
        // this.spinner.hide();
        this.isLoading = false;
        alertify.set("notifier", "position", "top-center");
        alertify.error("Error performing this operation");
      }
    );
  }

  confirmStatusChange(userId:any, status:any, name:any) {
    console.log(status);
    if (status == "ACTIVE") {
      this.passwordMatch = true;
      let dfModalRef = this.bsModalService.show(ConfirmDialogComponent, {
        initialState: {
          body:
              "Are you sure you want to Deactivate - " + name,
        },
        class: "modal-sm modal-dialog-centered",
      });
      dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
        this.saveUserDeactivation(userId);
        dfModalRef.hide();
      });
    } else {
      this.passwordMatch = true;
      let dfModalRef = this.bsModalService.show(ConfirmDialogComponent, {
        initialState: {
          body:
              "Are you sure you want to Activate this User " + name,
        },
        class: "modal-sm modal-dialog-centered",
      });
      dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
        this.activate(userId);
        dfModalRef.hide();
      });
    }
  }

  activate(userId:any) {
    let url = "/auth/activate?userId=" + userId;
      this.apiService.loginPost_(url, {}).subscribe(res=>{
        this.search();
      })
  }

  
}
